'use strict';

const compareByDepth = (a, b) => a.depth - b.depth;

exports.compareByDepth = compareByDepth;
//# sourceMappingURL=compare-by-depth.cjs.map
